import React from 'react';
import { Box } from '@material-ui/core';
import useApplicationStats from '€hooks/useApplicationsStats';
import DashboardApplicationCard from '../DashboardApplicationCard';

const DashboardApplicationList: React.FC = () => {
    const { inProgressApplicationStats } = useApplicationStats();

    return (
        <Box display="flex" flexDirection="column" flex="1">
            <Box width={{ xs: '27.75rem', md: '38.17rem', lg: '49.75rem' }} mr={1}>
                <Box
                    display="grid"
                    gridTemplateColumns={{
                        xs: 'repeat(2, 1fr)',
                        md: 'repeat(2, 1fr)',
                        lg: 'repeat(3, 1fr)',
                    }}
                    gridGap={{ xs: 16, sm: 32 }}
                >
                    {inProgressApplicationStats.map((stat, index) => (
                        <DashboardApplicationCard key={index} stat={stat} />
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default DashboardApplicationList;
